import { render, staticRenderFns } from "./memorialHall_video.vue?vue&type=template&id=5c7f6cff&scoped=true"
import script from "./memorialHall_video.vue?vue&type=script&lang=js"
export * from "./memorialHall_video.vue?vue&type=script&lang=js"
import style0 from "./memorialHall_video.vue?vue&type=style&index=0&id=5c7f6cff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f6cff",
  null
  
)

export default component.exports